import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ButtonComponent } from '@shared/components/button/button.component';
import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { InputComponent } from '@shared/components/input/input.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

import { ColumnChooserItemsComponent } from './components/column-chooser-items/column-chooser-items.component';
import { ColumnChooserNoItemsComponent } from './components/column-chooser-no-items/column-chooser-no-items.component';
import { ColumnChooserModel } from './model/column-chooser.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'h-[60vh] block',
  },
  imports: [
    InputComponent,
    ColumnChooserItemsComponent,
    CheckboxComponent,
    ColumnChooserNoItemsComponent,
    ButtonComponent,
  ],
  selector: 'aux-column-chooser-modal',
  standalone: true,
  templateUrl: './column-chooser-modal.component.html',
})
export class ColumnChooserModalComponent {
  ref = inject(
    CustomOverlayRef<
      undefined,
      { columns: ColumnChooserModel; reorder: boolean; showPinIcons: boolean }
    >
  );

  columns = signal<ColumnChooserModel | null>(null);
  searchTerm = signal('');

  chooser = viewChild<ColumnChooserItemsComponent>('chooser');

  isAllColumnsSelected = computed(() =>
    ColumnChooserModel.areAllColumnsSelected(this.chooser()?.mutableColumns() || [])
  );
  isAllColumnsIndeterminate = computed(
    () =>
      ColumnChooserModel.areAllColumnsIndeterminate(this.chooser()?.mutableColumns() || []) &&
      !this.isAllColumnsSelected()
  );

  fg = new FormGroup({});

  constructor() {
    this.columns.set(this.ref.data?.columns || null);
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;

    this.searchTerm.set(input.value);
  }

  onSelectAll(checked: boolean) {
    if (checked) {
      this.chooser()?.selectAll();
    } else {
      this.chooser()?.deselectAll();
    }
  }

  onUnpinAll() {
    this.chooser()?.unpinAll();
  }
}
